import { Component, OnInit, Input } from '@angular/core';

import { SharedAttachmentsService } from './shared-attachments.service';
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
    selector: 'app-shared-attachments',
    templateUrl: './shared-attachments.component.html',
    styleUrls: ['./shared-attachments.component.scss'],
})
export class SharedAttachmentsComponent implements OnInit {
    @Input() departmentType: any;
    private _sessionType: string;

    disableMasonry: boolean = true;

    loading: boolean = false;

    arrowRightIcon = faArrowCircleRight;
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any;

    constructor(
        private sharedAttachmentsService: SharedAttachmentsService,
        private router: Router,
        private route: ActivatedRoute,
        public sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {}

    /**
     * Observa a mudança do input e faz
     * um novo fetch do conteudo quando o
     * parametro muda
     * @see https://stackoverflow.com/questions/38571812/how-to-detect-when-an-input-value-changes-in-angular
     */
    @Input() set sessionType(value: string) {
        this._sessionType = value;
        this.attachedContent();
    }

    /**
     * attachedContent() - Buscar conteúdos/anexos publicados
     */
    attachedContent() {
        this.loading = true;
        this.sharedAttachmentsService.getAttachments(this.departmentType, this._sessionType).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    onCardClick(attached) {
        if (attached.text_full) {
            this.sharedAttachmentsService.singleAttachmentInstance.next(attached);
            this.router.navigate(['detail', attached.documento_id], { relativeTo: this.route });
        }
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.loading = false;

        if (this.registers.list.length === 1) {
            const attachment = this.registers.list[0];

            this.disableMasonry = attachment.content_type === 4;
        }
        // //console.log('attachedContent');
        // //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
        this.loading = false;
    }
}
